import React, { useEffect, useState } from "react";
import NoActiveBatches from "./NoActiveBatches";
import CreateBatch from "./CreateBatch";
import BatchTable from "./BatchTable";
import BatchDetailsSec from "./BatchDetailsSec";
import { createBatch, getAllBatch } from "../../../../api/globalAdmin/Index";
import WebUtils from "../../../../utils/WebUtils";
import CreatedSuccessModal from "./CreatedSuccessModal";

function ManageBatchesMain({ userDetail, setLoading }) {
  const [createbatchFlag, setCreateBatchFlag] = useState(false);
  const [allBatchData, setAllBatchData] = useState(null);
  const [sortBy, setSortBy] = useState("SORT_BY_CREATION_DATE_DESC");
  const [filter, setFilter] = useState("ALL");
  const [currentPage, setCurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(5);
  const [pageSize, setPageSize] = useState(5);

  const [searchText, setSearchText] = useState("");
  const [searchValue, setSearchValue] = useState("");

  const [createdSuccessFlag, setCreatedSuccessFlag] = useState(false);
  const [refressGetApi, setRefressGetApi] = useState(0);

  const getBatch = (pageNo, pageSize, searchInput) => {
    const url = `${getAllBatch}/getAllBatches?organizationId=${
      userDetail.organizationId || null
    }&candidateBatchState=${filter}&sortBy=${sortBy}&pageNumber=${pageNo}&pageSize=${pageSize}&searchValue=${searchInput}`;

    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setAllBatchData(result?.data?.data);
          setPageCount(result?.data?.data.totalCount);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const onPageChange = (num, pageSize) => {
    setCurrentPage(num - 1);
    setPageSize(pageSize);
  };

  const sortItems = [
    {
      key: "SORT_BY_CREATION_DATE_ASC",
      label: "Creation Date (Old-New)",
    },
    {
      key: "SORT_BY_CREATION_DATE_DESC",
      label: "Creation Date (New-Old)",
    },
    {
      key: "SORT_BY_BATCH_NAME_ASC",
      label: "Batch Name (A-Z)",
    },
    {
      key: "SORT_BY_BATCH_NAME_DESC",
      label: "Batch Name (Z-A)",
    },
  ];
  const filterItems = [
    {
      key: "ALL",
      label: "All",
    },
    {
      key: "ACTIVE",
      label: "Active",
    },
    {
      key: "INACTIVE",
      label: "Inactive",
    },
  ];

  useEffect(() => {
    getBatch(currentPage, pageSize, searchValue);
  }, [pageSize, currentPage, sortBy, refressGetApi, filter, searchValue]);

  return (
    <>
      {
        <CreatedSuccessModal
          setCreatedSuccessFlag={setCreatedSuccessFlag}
          createdSuccessFlag={createdSuccessFlag}
          setCreateBatchFlag={setCreateBatchFlag}
          setRefressGetApi={setRefressGetApi}
        />
      }
      <div>
        {createbatchFlag ? (
          <CreateBatch
            setCreateBatchFlag={setCreateBatchFlag}
            userDetail={userDetail}
            setLoading={setLoading}
            setCreatedSuccessFlag={setCreatedSuccessFlag}
          />
        ) : (
          <BatchDetailsSec
            allBatchData={allBatchData}
            setCreateBatchFlag={setCreateBatchFlag}
            pageCount={pageCount}
            currentPage={currentPage}
            onPageChange={onPageChange}
            pageSize={pageSize}
            getAllBatch={getAllBatch}
            sortItems={sortItems}
            filterItems={filterItems}
            filter={filter}
            setFilter={setFilter}
            setSortBy={setSortBy}
            sortBy={sortBy}
            searchText={searchText}
            setSearchText={setSearchText}
            setSearchValue={setSearchValue}
            searchValue={searchValue}
          />
        )}
      </div>
    </>
  );
}

export default ManageBatchesMain;
